import { Grid } from "@mui/material";

import FormInput from "../../../../components/hook-form/form-input.component";
import { FormSelect } from "../../../../components/hook-form/form-select.component";
import { LoadingIndicator } from "../../../../components/loading-indicator.component";

interface DetailsFormComponent {
    isLoading: boolean;
}

export const DetailsFormComponent = ({ isLoading }: DetailsFormComponent) => {
    return (
        <Grid container spacing={1}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={1}>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="workOrderNumber"
                            label="Work Order Number"
                            disabled
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="serviceGroupName"
                            label="Service Type (HERS or ESTAR)"
                            disabled
                        />
                        {/* <FormSelect
                            name="serviceType"
                            label="Service Type (HERS or ESTAR)"
                            options={[
                                { value: 'HERS', label: 'HERS' },
                                { value: 'ESTAR', label: 'ESTAR' }
                            ]} /> */}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={1}>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="customerName"
                            label="Customer"
                            disabled
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="officeName"
                            label="Office"
                            disabled
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="projectName"
                            label="Project"
                            disabled
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="unit"
                            label="Lots/Unit"
                            disabled
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="address"
                            label="Address"
                            disabled
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <LoadingIndicator isLoading={isLoading} />
                        <FormInput
                            name="jobsite"
                            label="Jobsite"
                            disabled
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}